// @ts-nocheck
export default function text_charts_displayer(chart) {
	let values = chart.parsedChartValues();

	chart.options("Value", values[0].value);
	chart.options("Label", values[0].label);
	chart.options("PrimaryColor", values[0].color);
}
